import React, { useEffect } from "react";
import TextInput from "@peracto/peracto-editor-ui/dist/TextInput";
import Textarea from "@peracto/peracto-editor-ui/dist/Textarea";
import Select from "@peracto/peracto-editor-ui/dist/Select";

import File from "@peracto/peracto-editor-ui/dist/File";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/pro-regular-svg-icons/faTrash";
import { faPlusCircle } from "@fortawesome/pro-regular-svg-icons/faPlusCircle";

const PanelGridForm = ({
    onChange,
    state: { panels, heading = "", selectedCardIndex },
}) => {
    const DEFAULT_CARD = {
        heading: "",
        text: "",
        buttonText: "",
        buttonLink: "",
        buttonColour: "primary",
        backgroundImage: "",
        backgroundColour: "brand-grey",
    };

    const buttonColourOptions = [
        { label: "Blue", value: "primary" },
        { label: "Orange", value: "tertiary" },
        { label: "Green", value: "sextary" },
        { label: "Pink", value: "quaternary" },
        { label: "Yellow", value: "quinary" },
        { label: "Transparent", value: "transparent" },
    ];

    useEffect(() => {
        return () => {
            onChange({ selectedCardIndex: null });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <TextInput
                label="Heading"
                onChange={(e) => {
                    onChange({ heading: e.target.value });
                }}
                value={heading}
            />
            {panels?.length === 0 && (
                <>
                    <p>Click 'Add Square Panel' to get started</p>
                    <hr />
                </>
            )}
            {selectedCardIndex !== null &&
                panels &&
                panels[selectedCardIndex] && (
                    <>
                        <TextInput
                            label="Panel Heading"
                            onChange={(e) => {
                                const panelsClone = [...panels];
                                panelsClone[selectedCardIndex].heading =
                                    e.target.value;

                                onChange({
                                    panels: panelsClone,
                                });
                            }}
                            value={panels[selectedCardIndex].heading}
                        />

                        <Textarea
                            label="Panel Text"
                            onChange={(e, editor) => {
                                const panelsClone = [...panels];
                                panelsClone[selectedCardIndex].text =
                                    editor.getData();

                                onChange({
                                    panels: panelsClone,
                                });
                            }}
                            value={panels[selectedCardIndex].text}
                        />

                        <TextInput
                            label="Panel Button Text"
                            onChange={(e) => {
                                const panelsClone = [...panels];
                                panelsClone[selectedCardIndex].buttonText =
                                    e.target.value;

                                onChange({
                                    panels: panelsClone,
                                });
                            }}
                            value={panels[selectedCardIndex].buttonText}
                        />

                        <TextInput
                            label="Panel Button Link"
                            onChange={(e) => {
                                const panelsClone = [...panels];
                                panelsClone[selectedCardIndex].buttonLink =
                                    e.target.value;

                                onChange({
                                    panels: panelsClone,
                                });
                            }}
                            value={panels[selectedCardIndex].buttonLink}
                        />

                        <Select
                            label="Panel Button Colour"
                            value={panels[selectedCardIndex].buttonColour}
                            onChange={(e) => {
                                const panelsClone = [...panels];
                                panelsClone[selectedCardIndex].buttonColour =
                                    e.value;

                                onChange({
                                    panels: panelsClone,
                                });
                            }}
                            options={buttonColourOptions}
                        />

                        <File
                            label="Panel Background Image URL"
                            value={panels[selectedCardIndex].backgroundImage}
                            onChange={(value) => {
                                const panelsClone = [...panels];
                                panelsClone[selectedCardIndex].backgroundImage =
                                    value;

                                onChange({
                                    panels: panelsClone,
                                });
                            }}
                            isInline={false}
                        />

                        <button
                            className="btn btn-sm btn-danger w-100 mt-2"
                            onClick={(e) => {
                                const panelsClone = [...panels];

                                panelsClone.splice(selectedCardIndex, 1);

                                onChange({
                                    panels: panelsClone,
                                });
                            }}
                        >
                            <FontAwesomeIcon icon={faTrash} className="mr-2" />{" "}
                            Remove Panel
                        </button>
                    </>
                )}

            <hr className="my-2" />

            <button
                className="btn btn-sm btn-secondary w-100"
                onClick={(e) => {
                    e.preventDefault();

                    const panelsClone = [...panels, DEFAULT_CARD];
                    onChange({
                        panels: panelsClone,
                    });
                }}
            >
                <FontAwesomeIcon icon={faPlusCircle} className="mr-2" /> Add
                Panel
            </button>
        </>
    );
};

export default PanelGridForm;
